import { firebaseAuth, db } from '../../config/firebaseConfig'

const state = {
  isLoggedIn: firebaseAuth().currentUser != null,
  user: firebaseAuth().currentUser,
  userDetails: {}
}

const mutations = {
  'AUTH_STATUS_CHANGE' (state) {
    state.isLoggedIn = firebaseAuth().currentUser != null
    state.user = firebaseAuth().currentUser
  },
  'SET_USER_DETAILS' (state, userDetails) {
    state.userDetails = userDetails
  },
  'SET_DELIVERY_ADDRESS' (state, address) {
    state.userDetails.deliveryAddress = address
  }
}

const actions = {
  logout ({ dispatch }) {
    dispatch('clearCart') // clear current cart
    return firebaseAuth().signOut()
  },
  loginWithEmail (_, { email, password }) {
    return firebaseAuth().signInWithEmailAndPassword(email, password)
  },
  resetPassword (_, { email }) {
    return firebaseAuth().sendPasswordResetEmail(email)
  },
  saveUserDetails ({ commit, getters }, { uid, firstname, lastname, mobile }) {
    commit('SET_USER_DETAILS', { firstname: firstname, lastname: lastname, phone: mobile })
    return db().ref(`/customers/${uid}`).update({ firstname: firstname, lastname: lastname, phone: mobile })
  },
  saveDeliveryAddress ({ commit, getters }, address) {
    commit('SET_DELIVERY_ADDRESS', address)
    return db().ref(`/customers/${getters.currentUser.uid}/deliveryAddress`).update(address)
  },
  getUserDetails ({ commit, getters, dispatch }) {
    let uid = getters['currentUser'].uid
    if (uid) {
      if (getters.shopId) {
        dispatch('bindOrders')
      }
      return db().ref(`/customers/${uid}`).once('value').then((userDetails) => {
        commit('SET_USER_DETAILS', userDetails.val())
      })
    } else {
      // console.log("User has not logged in");
    }
  },
  registerByEmail (_, { email, password }) {
    return firebaseAuth().createUserWithEmailAndPassword(email, password)
  }
}

const getters = {
  isLoggedIn: (state) => {
    return state.isLoggedIn
  },
  currentUser: (state) => {
    if (state && state.user) {
      return {
        email: state.user.email,
        emailVerified: state.user.emailVerified,
        uid: state.user.uid,
        ...state.userDetails
      }
    } else {
      return null
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
